export const SvgX = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"300"%20height%3D"271"%3E%3Cpath%20d%3D"M236%200h46L181%20115l118%20156h-92.6l-72.5-94.8-83%2094.8h-46l107-123L-1.1%200h94.9l65.5%2086.6zm-16.1%20244h25.5L80.4%2026H53z"%2F%3E%3C%2Fsvg%3E';
export default SvgX;
